import { render, staticRenderFns } from "./AmazonPaymentForm.vue?vue&type=template&id=8234de5c&scoped=true&"
import script from "./AmazonPaymentForm.vue?vue&type=script&lang=js&"
export * from "./AmazonPaymentForm.vue?vue&type=script&lang=js&"
import style0 from "./AmazonPaymentForm.vue?vue&type=style&index=0&id=8234de5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8234de5c",
  null
  
)

export default component.exports